module.exports = __webpack_public_path__ + "static/media/cnpq.01807558.png";